import React from 'react';
import { SearchSortByProps } from './../../../types/search';

const SearchSortBy = ({
  options,
  selected,
  onChange,
  labels,
}: SearchSortByProps & { labels?: { sortByLabel?: string } }) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="search__sort-by">
      <label htmlFor="search-sort-by" className="search__filters-label">
        {labels?.sortByLabel || 'Sort by'}
      </label>
      <select id="search-sort-by" className="search__sort-by-select" value={selected} onChange={handleChange}>
        {options.map(option => (
          <option className="search__sort-by-select-option" key={option.order} value={option.order}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SearchSortBy;
